import { Component } from 'react';
import RichTextEditor from 'react-rte';
import { TOOL_BAR_CONFIG } from '../../../constants/index';

export default class RichtextEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: RichTextEditor.createValueFromString(
        this.props.value || '',
        'html',
      ),
      html: '',
      toolbarConfig: TOOL_BAR_CONFIG,
    };
  }

  onChange = (value) => {
    this.setState({ value, html: value.toString('html') }, () => {
      this.props.onSave(this.state.html);
    });
    if (this.props.onChange) {
      this.props.onChange(value.toString('html'));
    }
  };

  componentDidMount() {
    if (this?.props?.displayExtraToolbarOptions?.length > 0) {
      const updatedDisplayConfig = [
        ...this.state.toolbarConfig.display,
        ...this.props.displayExtraToolbarOptions,
      ];
      const updatedConfig = {
        ...TOOL_BAR_CONFIG,
        display: updatedDisplayConfig,
      };
      this.setState({ ...this.state, toolbarConfig: updatedConfig });
    }
  }

  render() {
    return (
      <>
        <RichTextEditor
          value={this.state.value}
          onChange={this.onChange}
          autoFocus={this?.props?.autoFocus === false ? false : true}
          placeholder=""
          toolbarConfig={this?.state?.toolbarConfig || TOOL_BAR_CONFIG}
        />
      </>
    );
  }
}
